import { Component, forwardRef, Inject, Input } from '@angular/core';
import { BlockUI, NgBlockUI }                   from 'ng-block-ui';
import { NgbActiveModal }                       from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }                     from '@ngx-translate/core';

import { BranchCustomersFiltersModel } from './typings/customers.branch.filters';
import { CodeTypeModel }               from '../core/models/code-type';
import { CustomerCopyFromBranchModel } from './typings/customer.copy-from-branch';
import { CustomerModel }               from './models/customer';
import { CustomersService }            from './customers.service';
import { MessagesService }             from '../messages/messages.service';
import { Table }                       from '../table/types/table';
import { TableQueryParameters }        from '../table/types/table-query-parameters';

@Component({
  selector   : 'wor-add-customer-from-branch',
  template: require('./customer.add-from-branch.component.html')
})
export class AddCustomerFromBranchComponent {
  @BlockUI('addFromBranchBlock') block: NgBlockUI;

  @Input() searchTypes: Array<CodeTypeModel> = [];

  customers       : Array<CustomerModel> = [];
  selectedCustomer: CustomerModel | null = null;

  filters: BranchCustomersFiltersModel = {
    searchTerm: '',
    searchType: 'email'
  };

  tableSettings: Table = {
    columns: [
      {
        field : 'store_name',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.STORE_NAME')
        }
      },
      {
        classes: 'all-caps',
        field  : 'first_name',
        header : {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.FIRST_NAME')
        }
      },
      {
        field : 'last_name',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.LAST_NAME')
        }
      },
      {
        field : 'email',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.EMAIL')
        }
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_CUSTOMERS_FOUND')
    },
    pagination: {
      enabled  : true,
      pageSize : 5,
      pageSizes: [ 5, 10, 25, 50 ]
    },
    rows: {
      highlight: {
        enabled: true
      },
      select: {
        enabled: true
      }
    },
    sorting: {
      direction: 'asc',
      enabled  : true,
      field    : 'store_name'
    },
    static: true
  };

  constructor (
    public  activeModal     : NgbActiveModal,
    @Inject(forwardRef(() => CustomersService))
    private customersService: CustomersService,
    private messagesService : MessagesService,
    private translateService: TranslateService
  ) {}

  confirm () : void {
    if ( !this.selectedCustomer ) {
      return;
    }

    this.block.start();

    this.customersService.copyFromBranch(this.selectedCustomer, this.selectedCustomer.vehicle_id)
      .then(( result : CustomerCopyFromBranchModel ) => this.activeModal.close(result))
      .catch(error => this.messagesService.error(error))
      .finally(() => this.block.stop());
  }

  confirmCustomerSelection ( customer : CustomerModel ) : void {
    this.selectedCustomer = customer;

    this.confirm();
  }

  getCustomers ( params : TableQueryParameters = {} ) : void {
    this.selectedCustomer = null;

    // The branch search route needs a term; production stayed quiet on an empty search.
    if ( !this.filters.searchTerm ) {
      return;
    }

    this.customersService.getBranchCustomers(this.filters, params)
      .then(customers => this.customers = customers)
      .catch(error => this.messagesService.error(error));
  }

  handleCustomerSelection ( customer : CustomerModel ) : void {
    this.selectedCustomer = customer.selected
      ? customer
      : null;
  }
}
